export const QC_INSPECTOR = "QC-INSPECTOR"
export const COPYRIGHT = "https://enqc.abacus.co.id"
export const BASE_URL = window.location.port?'http://217.15.166.218:6222/api':'https://enqc-api.abacus.co.id/api'
export const BASE_SERVER = window.location.port?'http://217.15.166.218:6222':'https://enqc-api.abacus.co.id'
export const DEBUG = false
